import React, { useState } from 'react';
import { Product, Category } from '../types/Product';
import ProductCard from './ProductCard';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

interface CategorySectionProps {
  category: Category;
  products: Product[];
  isOpen: boolean;
  region: 'US' | 'CA' | 'OTHER';
  onToggle: () => void;
}

const CategorySection: React.FC<CategorySectionProps> = ({
  category,
  products,
  isOpen,
  region,
  onToggle,
}) => {
  return (
    <div className="mb-8">
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-between rounded-lg bg-dark-secondary p-4 text-left transition-colors hover:bg-gradient-to-r hover:from-gradient-start hover:to-gradient-end"
      >
        <h2 className="text-xl font-bold text-white">{category.name}</h2>
        {isOpen ? (
          <FaChevronUp className="text-dark-text-secondary" />
        ) : (
          <FaChevronDown className="text-dark-text-secondary" />
        )}
      </button>

      <div
        className={`grid-cols-1 gap-6 transition-all duration-300 md:grid-cols-2 lg:grid-cols-3 ${
          isOpen ? 'grid mt-4' : 'hidden'
        }`}
      >
        {products.map((product) => (
          <ProductCard key={product.id} product={product} region={region} />
        ))}
      </div>
    </div>
  );
};

export default CategorySection; 